import { getFontPropeties } from '../../../apis/services/editActionsServices/nativeActions/globalDesign/constants';
import { StylesGroup } from '../types';

export const textGroupDisplayFilter = (
  groups: StylesGroup[],
): StylesGroup[] => {
  if (groups.length === 0) {
    return groups;
  }

  return groups.filter((group) => hasFontProperties(group));
};

type FontCssPropertyType = ReturnType<typeof getFontPropeties>[number];

const hasFontProperties = (group: StylesGroup): boolean => {
  const fontProperties = new Set(getFontPropeties());

  if (group.styleNamespace === 'cssProperties') {
    const cssPropertyTypes = group.items.map(
      (item) => item.styleItemId,
    ) as FontCssPropertyType[];

    return cssPropertyTypes.some((type) => fontProperties.has(type));
  }

  if (group.styleNamespace === 'cssCustomProperties') {
    const definitions = group.context.resolver.getStyleDefinitions();
    const cssCustomPropertyTypes = [];

    for (const item of group.items) {
      const definition = definitions.cssCustomProperties[item.styleItemId];
      if (definition && definition.cssPropertyType) {
        cssCustomPropertyTypes.push(definition.cssPropertyType);
      }
    }

    return cssCustomPropertyTypes.some((type) =>
      fontProperties.has(type as FontCssPropertyType),
    );
  }

  return false;
};
